import React from 'react'
import styled from 'styled-components/macro'
import {
  Tooltip,
  TooltipOverlayType,
  TooltipPositions,
} from '../Tooltip/Tooltip'
import { BasicChip } from './BasicChip'

export const ChipRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`

// Stands in for the chips that don't fit, e.g. "+ 2".
export const OverflowCountChip = ({
  count,
}: {
  count: number
}): JSX.Element => <BasicChip flex="0 0 auto">{`+ ${count}`}</BasicChip>

/**
 * The first item as a chip and the rest collapsed into a "+ N" chip, which lists
 * them on hover.
 */
export const ChipSummary = ({
  items,
  tooltipId,
}: {
  items: string[]
  tooltipId: string
}): JSX.Element => {
  const [first, ...rest] = items

  if (rest.length === 0) {
    return <BasicChip>{first}</BasicChip>
  }

  return (
    <Tooltip
      id={tooltipId}
      placement={TooltipPositions.top}
      overlayType={TooltipOverlayType.popover}
      tooltipBody={rest.join(', ')}
    >
      <ChipRow>
        <BasicChip flex="0 1 auto">{first}</BasicChip>
        <OverflowCountChip count={rest.length} />
      </ChipRow>
    </Tooltip>
  )
}
